import React, { Component } from "react";
import "./Retnet2018.css";


export default class Retnet2018 extends Component {

  render() {
    // <div id="pdfschedule">
    //     <embed src="/images/RETNET2019schedule.pdf" width="100%"
    //             height="1000px" alt="pdf"
    //             pluginspage="http://www.adobe.com/products/acrobat/readstep2.html" />
    // </div>
      return (
          <div>
              <div className="container-fluid text-center">
                  <br />
                  {/*<div className="fontbolder" >RetNet-2022 Schedule</div>*/}
                  {/*<br />*/}

                      <img className="schedule_img" src="/images/retnet_ap_meet_schedule_1.png" />
                      <img className="schedule_img" src="/images/retnet_ap_meet_schedule_2.png" />
                      <img className="schedule_img"  src="/images/retnet_ap_meet_schedule_3.png" />
                      <img className="schedule_img" src="/images/retnet_ap_meet_schedule_4.png" />
                      {/*<img className="schedule_img" src="/images/retnet2024_schedule_5.png" />*/}
                      {/*  <img className="schedule_img" src="/images/retnet2024_schedule_6.png" />*/}
                      {/*<img src="/assets/images/2019schedule2.png" />*/}
                      {/*<br />*/}
                      {/*<br />*/}
                      {/*<br />*/}
                      {/*<img src="/assets/images/2019schedule3.png" />*/}
                      {/*<img src="/assets/images/2019schedule4.png" />*/}

              </div>

              <span className="space-xs-xl"></span>
          </div>

      );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Retnet2018.js